module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container modal-container-result-insurer"
  }, [_c('div', {
    staticClass: "modal-header modal-header-result-insurer"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": (_vm.imagesPath || 'images/login-seguradoras') + '/' + _vm.seguradora.seguradora + '.png',
      "alt": _vm.seguradora.nome,
      "width": "30"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.seguradora.nome_abreviado))]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-body-result-insurer"
  }, [_c('div', {
    staticClass: "timeout-icon"
  }, [_c('icon', {
    attrs: {
      "name": "clock-o",
      "scale": "3"
    }
  })], 1), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91bc5dea","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/enterprise/modules/Result/PartialModalTimeoutDetails.vue
// module id = 347
// module chunks = 0